import { render, staticRenderFns } from "./CancelledBoxModal.vue?vue&type=template&id=cd1ef26c&scoped=true"
import script from "./CancelledBoxModal.vue?vue&type=script&lang=js"
export * from "./CancelledBoxModal.vue?vue&type=script&lang=js"
import style0 from "./CancelledBoxModal.vue?vue&type=style&index=0&id=cd1ef26c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1ef26c",
  null
  
)

export default component.exports